import React from 'react'
import { observer } from 'mobx-react-lite'

import { wbMatchingProps } from './MatchWbToMoySkladButton'
import { ozonMatchingProps } from './MatchOzonToMoySkladButton'
import { ymMatchingProps } from './MatchYandexMarketToMoySkladButton'
import { AutoMatchNewStoreProductsButton } from './AutoMatchNewStoreProductsButton'

import { useLogic } from '../hooks/storeHook'
import { useStoreAccountOptional } from '../hooks/routeHooks'

import { UnprocessedValueError } from '../common/tsUtils'

import { IntegrationType } from '../server/mpsklad_core/Entity/IntegrationType'

export const AutoMatchNewProductsButton =
  observer(() => {
    const logic = useLogic()
    const account = useStoreAccountOptional()

    if (!account) {
      console.error(`Bad account in AutoMatchNewProductsButton at ${window.location.href}`)
      return null
    }

    const {integrationType} = account

    // Keys are required, otherwise React reuses buttons for different accounts (at least in dev)
    switch (integrationType) {
      case IntegrationType.Ozon:
        return <AutoMatchNewStoreProductsButton
          key={`Ozon_${account.id}`}
          account={account}
          storeProps={ozonMatchingProps}
          initialStoreProp={account.autoMatchOzonProp}
          submit={logic.setAutoMatchNewOzonProducts}/>

      case IntegrationType.Wildberries:
        return <AutoMatchNewStoreProductsButton
          key={`Wb_${account.id}`}
          account={account}
          storeProps={wbMatchingProps}
          initialStoreProp={account.autoMatchWbProp}
          submit={logic.setAutoMatchNewWbProducts}/>

      case IntegrationType.YandexMarket:
        return <AutoMatchNewStoreProductsButton
          key={`Ym_${account.id}`}
          account={account}
          storeProps={ymMatchingProps}
          initialStoreProp={account.autoMatchYmProp}
          submit={logic.setAutoMatchNewYmProducts}/>

      default:
        throw new UnprocessedValueError('StoreIntegrationType', integrationType)
    }
  })